module.exports = "/images/centro_comunitario.svg?c6a753742676bccfab2309c521fd9260";